import React, { createContext, useContext, useState, useCallback } from "react";

const translations = {
  nl: {
    "nav.how": "Hoe werkt het",
    "nav.repairs": "Herstellingen",
    "nav.faq": "FAQ",
    "nav.login": "Inloggen",
    "nav.account": "Mijn opdrachten",
    "nav.book": "Boek een herstelling",
    "nav.logout": "Uitloggen",
    "nav.admin": "Admin",
    "nav.partner": "Partner",

    "hero.title": "Ramen of deuren die niet goed werken? Wij lossen het op.",
    "hero.subtitle": "Boek eenvoudig een lokale vakman voor kleine herstellingen aan ramen en deuren. Wij regelen de afspraak, opvolging en facturatie.",
    "hero.cta": "Boek een herstelling",
    "hero.cta2": "Ik weet niet wat er mis is",
    "hero.badge1": "100% lokale Belgische vakmannen",
    "hero.badge2": "Eén aanspreekpunt",
    "hero.badge3": "Eén duidelijke factuur",

    "value.prop": "Jij meldt het probleem. Wij regelen de rest.",

    "popular.title": "Populaire herstellingen",
    "popular.subtitle": "Kies uw probleem en zie meteen de indicatieve prijs.",
    "popular.from": "vanaf",
    "popular.book": "Boeken",

    "how.title": "Hoe werkt het?",
    "how.1": "Beschrijf je probleem",
    "how.2": "Upload eventueel foto's",
    "how.3": "Kies een geschikt moment",
    "how.4": "Wij regelen een lokale vakman",
    "how.5": "De herstelling wordt uitgevoerd",
    "how.6": "Je ontvangt één duidelijke factuur",

    "trust.title": "Eén aanspreekpunt van aanvraag tot herstelling.",
    "trust.subtitle": "U werkt met één professionele organisatie. Wij coördineren de lokale vakman, de planning en de facturatie.",

    "reviews.title": "Wat klanten zeggen",
    "reviews.none": "Nog geen beoordelingen beschikbaar.",
    "reviews.based": "gebaseerd op",
    "reviews.count": "beoordelingen",

    "faq.title": "Veelgestelde vragen",

    "footer.tagline": "Kleine herstellingen aan ramen en deuren in heel België.",
    "footer.company": "Bedrijf",
    "footer.legal": "Juridisch",
    "footer.privacy": "Privacybeleid",
    "footer.cookies": "Cookiebeleid",
    "footer.terms": "Algemene voorwaarden",
    "footer.rights": "Alle rechten voorbehouden.",

    "wizard.title": "Boek een herstelling",
    "wizard.step": "Stap",
    "wizard.of": "van",
    "wizard.next": "Volgende",
    "wizard.back": "Terug",
    "wizard.confirm": "Herstelling boeken",
    "wizard.s1.title": "Wat is het probleem?",
    "wizard.s2.title": "Waar gaat het probleem over?",
    "wizard.s2.material": "Materiaal",
    "wizard.s2.type": "Gaat het om een raam of een deur?",
    "wizard.raam": "Raam",
    "wizard.deur": "Deur",
    "wizard.s3.title": "Om hoeveel ramen/deuren gaat het?",
    "wizard.s4.title": "Foto's toevoegen",
    "wizard.s4.help": "Een foto helpt ons om het probleem beter in te schatten en de juiste vakman te voorzien van informatie.",
    "wizard.s4.upload": "Foto's uploaden",
    "wizard.s4.optional": "Optioneel — u kunt meerdere foto's toevoegen (JPG, PNG, WEBP).",
    "wizard.s5.title": "Waar moeten we langskomen?",
    "wizard.street": "Straat",
    "wizard.house": "Huisnummer",
    "wizard.postal": "Postcode",
    "wizard.city": "Gemeente",
    "wizard.s6.title": "Uw contactgegevens",
    "wizard.firstname": "Voornaam",
    "wizard.lastname": "Achternaam",
    "wizard.phone": "Telefoonnummer",
    "wizard.email": "E-mailadres",
    "wizard.s7.title": "Uw afspraak plannen",
    "wizard.s7.info": "U hoeft zelf geen datum te kiezen. Zodra we een geschikte lokale vakman hebben gevonden, nemen wij contact met u op om samen een geschikt moment te plannen.",
    "wizard.price_note": "U betaalt niets vooraf. U ontvangt een duidelijke prijs voordat de herstelling wordt ingepland.",
    "wizard.estimate.label": "Geschatte prijs",
    "wizard.estimate.note": "Dit is een indicatieve schatting. De uiteindelijke prijs kan variëren, bijvoorbeeld wanneer er onderdelen besteld moeten worden. U ontvangt altijd een duidelijke prijs voordat de herstelling wordt ingepland.",
    "wizard.to_be_scheduled": "Nog te plannen",
    "wizard.asap": "Zo snel mogelijk",
    "wizard.this_week": "Deze week",
    "wizard.next_week": "Volgende week",
    "wizard.s8.title": "Overzicht van uw boeking",
    "wizard.summary.repair": "Herstelling",
    "wizard.summary.material": "Materiaal",
    "wizard.summary.qty": "Aantal",
    "wizard.summary.location": "Locatie",
    "wizard.summary.appointment": "Afspraak",
    "wizard.summary.price": "Prijs (incl. btw)",
    "wizard.dontknow": "Ik weet het niet",
    "wizard.pay.title": "Betaling",
    "wizard.pay.help": "Rond uw boeking af met een veilige betaling. (Testmodus)",
    "wizard.pay.btn": "Betaal en bevestig",
    "wizard.done.title": "Boeking bevestigd!",
    "wizard.done.msg": "Bedankt voor uw aanvraag. We hebben uw aanvraag goed ontvangen en zoeken een geschikte lokale hersteller.",
    "wizard.done.number": "Uw opdrachtnummer",
    "wizard.done.account": "Bekijk in mijn account",
    "wizard.done.home": "Terug naar home",

    "status.awaiting_payment": "Wacht op betaling",
    "status.searching_partner": "Hersteller zoeken",
    "status.partner_assigned": "Hersteller toegewezen",
    "status.appointment_pending": "Afspraak in te plannen",
    "status.appointment_confirmed": "Afspraak bevestigd",
    "status.in_progress": "Uitvoering bezig",
    "status.completed": "Opdracht afgerond",
    "status.cancelled": "Geannuleerd",
    "status.new": "Nieuw",
    "status.paid": "Betaald",
    "status.pending": "In afwachting",
    "status.failed": "Mislukt",
    "status.refunded": "Terugbetaald",

    "auth.login": "Inloggen",
    "auth.register": "Account aanmaken",
    "auth.email": "E-mailadres",
    "auth.password": "Wachtwoord",
    "auth.name": "Naam",
    "auth.phone": "Telefoon",
    "auth.noaccount": "Nog geen account?",
    "auth.hasaccount": "Al een account?",
    "auth.loginbtn": "Inloggen",
    "auth.registerbtn": "Registreren",

    "account.title": "Mijn opdrachten",
    "account.empty": "U heeft nog geen opdrachten.",
    "account.book": "Boek een herstelling",
    "account.viewinvoice": "Factuur bekijken",
    "account.leavereview": "Beoordeling geven",
    "account.timeline": "Statusoverzicht",
    "common.loading": "Laden...",
    "common.close": "Sluiten",
  },
  fr: {
    "nav.how": "Comment ça marche",
    "nav.repairs": "Réparations",
    "nav.faq": "FAQ",
    "nav.login": "Connexion",
    "nav.account": "Mes commandes",
    "nav.book": "Réserver une réparation",
    "nav.logout": "Déconnexion",
    "nav.admin": "Admin",
    "nav.partner": "Partenaire",

    "hero.title": "Fenêtres ou portes qui fonctionnent mal ? Nous réglons ça.",
    "hero.subtitle": "Réservez facilement un artisan local pour de petites réparations de fenêtres et portes. Nous organisons le rendez-vous, le suivi et la facturation.",
    "hero.cta": "Réserver une réparation",
    "hero.cta2": "Je ne sais pas ce qui ne va pas",
    "hero.badge1": "100% artisans locaux belges",
    "hero.badge2": "Un seul point de contact",
    "hero.badge3": "Une facture claire",

    "value.prop": "Vous signalez le problème. Nous réglons le reste.",

    "popular.title": "Réparations populaires",
    "popular.subtitle": "Choisissez votre problème et voyez le prix indicatif immédiatement.",
    "popular.from": "à partir de",
    "popular.book": "Réserver",

    "how.title": "Comment ça marche ?",
    "how.1": "Décrivez votre problème",
    "how.2": "Téléchargez éventuellement des photos",
    "how.3": "Choisissez un moment",
    "how.4": "Nous organisons un artisan local",
    "how.5": "La réparation est effectuée",
    "how.6": "Vous recevez une facture claire",

    "trust.title": "Un point de contact, de la demande à la réparation.",
    "trust.subtitle": "Vous travaillez avec une seule organisation professionnelle. Nous coordonnons l'artisan local, la planification et la facturation.",

    "reviews.title": "Ce que disent les clients",
    "reviews.none": "Aucune évaluation disponible pour le moment.",
    "reviews.based": "basé sur",
    "reviews.count": "évaluations",

    "faq.title": "Questions fréquentes",

    "footer.tagline": "Petites réparations de fenêtres et portes dans toute la Belgique.",
    "footer.company": "Entreprise",
    "footer.legal": "Juridique",
    "footer.privacy": "Politique de confidentialité",
    "footer.cookies": "Politique de cookies",
    "footer.terms": "Conditions générales",
    "footer.rights": "Tous droits réservés.",

    "wizard.title": "Réserver une réparation",
    "wizard.step": "Étape",
    "wizard.of": "sur",
    "wizard.next": "Suivant",
    "wizard.back": "Retour",
    "wizard.confirm": "Réserver la réparation",
    "wizard.s1.title": "Quel est le problème ?",
    "wizard.s2.title": "De quoi s'agit-il ?",
    "wizard.s2.material": "Matériau",
    "wizard.s2.type": "S'agit-il d'une fenêtre ou d'une porte ?",
    "wizard.raam": "Fenêtre",
    "wizard.deur": "Porte",
    "wizard.s3.title": "Combien de fenêtres/portes ?",
    "wizard.s4.title": "Ajouter des photos",
    "wizard.s4.help": "Une photo nous aide à mieux évaluer le problème et à informer le bon artisan.",
    "wizard.s4.upload": "Télécharger des photos",
    "wizard.s4.optional": "Facultatif — vous pouvez ajouter plusieurs photos (JPG, PNG, WEBP).",
    "wizard.s5.title": "Où devons-nous intervenir ?",
    "wizard.street": "Rue",
    "wizard.house": "Numéro",
    "wizard.postal": "Code postal",
    "wizard.city": "Commune",
    "wizard.s6.title": "Vos coordonnées",
    "wizard.firstname": "Prénom",
    "wizard.lastname": "Nom",
    "wizard.phone": "Téléphone",
    "wizard.email": "E-mail",
    "wizard.s7.title": "Planifier votre rendez-vous",
    "wizard.s7.info": "Vous ne devez pas choisir de date vous-même. Dès que nous avons trouvé un artisan local adapté, nous vous contactons pour convenir ensemble d'un moment qui vous convient.",
    "wizard.price_note": "Vous ne payez rien à l'avance. Vous recevez un prix clair avant que la réparation ne soit planifiée.",
    "wizard.estimate.label": "Prix estimé",
    "wizard.estimate.note": "Ceci est une estimation indicative. Le prix final peut varier, par exemple si des pièces doivent être commandées. Vous recevez toujours un prix clair avant que la réparation ne soit planifiée.",
    "wizard.to_be_scheduled": "À planifier",
    "wizard.asap": "Dès que possible",
    "wizard.this_week": "Cette semaine",
    "wizard.next_week": "La semaine prochaine",
    "wizard.s8.title": "Aperçu de votre réservation",
    "wizard.summary.repair": "Réparation",
    "wizard.summary.material": "Matériau",
    "wizard.summary.qty": "Quantité",
    "wizard.summary.location": "Localisation",
    "wizard.summary.appointment": "Rendez-vous",
    "wizard.summary.price": "Prix (TVA incl.)",
    "wizard.dontknow": "Je ne sais pas",
    "wizard.pay.title": "Paiement",
    "wizard.pay.help": "Finalisez votre réservation avec un paiement sécurisé. (Mode test)",
    "wizard.pay.btn": "Payer et confirmer",
    "wizard.done.title": "Réservation confirmée !",
    "wizard.done.msg": "Merci pour votre demande. Nous l'avons bien reçue et cherchons un artisan local adapté.",
    "wizard.done.number": "Votre numéro de commande",
    "wizard.done.account": "Voir dans mon compte",
    "wizard.done.home": "Retour à l'accueil",

    "status.awaiting_payment": "En attente de paiement",
    "status.searching_partner": "Recherche d'un artisan",
    "status.partner_assigned": "Artisan assigné",
    "status.appointment_pending": "Rendez-vous à planifier",
    "status.appointment_confirmed": "Rendez-vous confirmé",
    "status.in_progress": "Intervention en cours",
    "status.completed": "Commande terminée",
    "status.cancelled": "Annulé",
    "status.new": "Nouveau",
    "status.paid": "Payé",
    "status.pending": "En attente",
    "status.failed": "Échoué",
    "status.refunded": "Remboursé",

    "auth.login": "Connexion",
    "auth.register": "Créer un compte",
    "auth.email": "E-mail",
    "auth.password": "Mot de passe",
    "auth.name": "Nom",
    "auth.phone": "Téléphone",
    "auth.noaccount": "Pas encore de compte ?",
    "auth.hasaccount": "Déjà un compte ?",
    "auth.loginbtn": "Se connecter",
    "auth.registerbtn": "S'inscrire",

    "account.title": "Mes commandes",
    "account.empty": "Vous n'avez pas encore de commandes.",
    "account.book": "Réserver une réparation",
    "account.viewinvoice": "Voir la facture",
    "account.leavereview": "Laisser un avis",
    "account.timeline": "Suivi du statut",
    "common.loading": "Chargement...",
    "common.close": "Fermer",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("rh_lang") || "nl");
  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("rh_lang", l);
  }, []);
  const t = useCallback((key) => translations[lang][key] || translations.nl[key] || key, [lang]);
  return (
    <I18nContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
